const provinceList = [
	{
		city: "Agrigento",
		plate: "AG", 
		region: "Sicilia"
	},
	{
		city: "Alessandria",
		plate: "AL", 
		region: "Piemonte"
	},
	{
		city: "Ancona",
		plate: "AN", 
		region: "Marche"
	},
	{
		city: "Aosta",
		plate: "AO", 
		region: "Valle d'Aosta"
	},
	{
		city: "LAquila",
		plate: "AQ", 
		region: "Abruzzo"
	},
	{
		city: "Arezzo",
		plate: "AR", 
		region: "Toscana"
	},
	{
		city: "Ascoli Piceno",
		plate: "AP", 
		region: "Marche"
	},
	{
		city: "Asti",
		plate: "AT", 
		region: "Piemonte"
	},
	{
		city: "Avellino",
		plate: "AV", 
		region: "Campania"
	},
	{
		city: "Bari",
		plate: "BA", 
		region: "Puglia"
	},
	{
		city: "Barletta-Andria-Trani",
		plate: "BT", 
		region: "Puglia"
	},
	{
		city: "Belluno",
		plate: "BL", 
		region: "Veneto"
	},
	{
		city: "Benevento",
		plate: "BN", 
		region: "Campania"
	},
	{
		city: "Bergamo",
		plate: "BG", 
		region: "Lombardia"
	},
	{
		city: "Biella",
		plate: "BI", 
		region: "Piemonte"
	},
	{
		city: "Bologna",
		plate: "BO", 
		region: "Emilia Romagna"
	},
	{
		city: "Bolzano",
		plate: "BZ", 
		region: "Trentino Alto Adige"
	},
	{
		city: "Brescia",
		plate: "BS", 
		region: "Lombardia"
	},
	{
		city: "Brindisi",
		plate: "BR", 
		region: "Puglia"
	},
	{
		city: "Cagliari",
		plate: "CA", 
		region: "Sardegna"
	},
	{
		city: "Caltanissetta",
		plate: "CL", 
		region: "Sicilia"
	},
	{
		city: "Campobasso",
		plate: "CB", 
		region: "Molise"
	},
	{
		city: "Carbonia Iglesias",
		plate: "CI", 
		region: "Sardegna"
	},
	{
		city: "Caserta",
		plate: "CE", 
		region: "Campania"
	},
	{
		city: "Catania",
		plate: "CT", 
		region: "Sicilia"
	},
	{
		city: "Catanzaro",
		plate: "CZ", 
		region: "Calabria"
	},
	{
		city: "Chieti",
		plate: "CH", 
		region: "Abruzzo"
	},
	{
		city: "Como",
		plate: "CO", 
		region: "Lombardia"
	},
	{
		city: "Cosenza",
		plate: "CS", 
		region: "Calabria"
	},
	{
		city: "Cremona",
		plate: "CR", 
		region: "Lombardia"
	},
	{
		city: "Crotone",
		plate: "KR", 
		region: "Calabria"
	},
	{
		city: "Cuneo",
		plate: "CN", 
		region: "Piemonte"
	},
	{
		city: "Enna",
		plate: "EN", 
		region: "Sicilia"
	},
	{
		city: "Fermo",
		plate: "FM", 
		region: "Marche"
	},
	{
		city: "Ferrara",
		plate: "FE", 
		region: "Emilia Romagna"
	},
	{
		city: "Firenze",
		plate: "FI", 
		region: "Toscana"
	},
	{
		city: "Foggia",
		plate: "FG", 
		region: "Puglia"
	},
	{
		city: "Forli Cesena",
		plate: "FC", 
		region: "Emilia Romagna"
	},
	{
		city: "Frosinone",
		plate: "FR", 
		region: "Lazio"
	},
	{
		city: "Genova",
		plate: "GE", 
		region: "Liguria"
	},
	{
		city: "Gorizia",
		plate: "GO", 
		region: "Friuli Venezia Giulia"
	},
	{
		city: "Grosseto",
		plate: "GR", 
		region: "Toscana"
	},
	{
		city: "Imperia",
		plate: "IM", 
		region: "Liguria"
	},
	{
		city: "Isernia",
		plate: "IS", 
		region: "Molise"
	},
	{
		city: "La Spezia",
		plate: "SP", 
		region: "Liguria"
	},
	{
		city: "Latina",
		plate: "LT", 
		region: "Lazio"
	},
	{
		city: "Lecce",
		plate: "LE", 
		region: "Puglia"
	},
	{
		city: "Lecco",
		plate: "LC", 
		region: "Lombardia"
	},
	{
		city: "Livorno",
		plate: "LI", 
		region: "Toscana"
	},
	{
		city: "Lodi",
		plate: "LO", 
		region: "Lombardia"
	},
	{
		city: "Lucca",
		plate: "LU", 
		region: "Toscana"
	},
	{
		city: "Macerata",
		plate: "MC", 
		region: "Marche"
	},
	{
		city: "Mantova",
		plate: "MN", 
		region: "Lombardia"
	},
	{
		city: "Massa Carrara",
		plate: "MS", 
		region: "Toscana"
	},
	{
		city: "Matera",
		plate: "MT", 
		region: "Basilicata"
	},
	{
		city: "Medio Campidano",
		plate: "VS", 
		region: "Sardegna"
	},
	{
		city: "Messina",
		plate: "ME", 
		region: "Sicilia"
	},
	{
		city: "Milano",
		plate: "MI", 
		region: "Lombardia"
	},
	{
		city: "Modena",
		plate: "MO", 
		region: "Emilia Romagna"
	},
	{
		city: "Monza Brianza",
		plate: "MB", 
		region: "Lombardia"
	},
	{
		city: "Napoli",
		plate: "NA", 
		region: "Campania"
	},
	{
		city: "Novara",
		plate: "NO", 
		region: "Piemonte"
	},
	{
		city: "Nuoro",
		plate: "NU", 
		region: "Sardegna"
	},
	{
		city: "Ogliastra",
		plate: "OG", 
		region: "Sardegna"
	},
	{
		city: "Olbia Tempio",
		plate: "OT", 
		region: "Sardegna"
	},
	{
		city: "Oristano",
		plate: "OR", 
		region: "Sardegna"
	},
	{
		city: "Padova",
		plate: "PD", 
		region: "Veneto"
	},
	{
		city: "Palermo",
		plate: "PA", 
		region: "Sicilia"
	},
	{
		city: "Parma",
		plate: "PR", 
		region: "Emilia Romagna"
	},
	{
		city: "Pavia",
		plate: "PV", 
		region: "Lombardia"
	},
	{
		city: "Perugia",
		plate: "PG", 
		region: "Umbria"
	},
	{
		city: "Pesaro Urbino",
		plate: "PU", 
		region: "Marche"
	},
	{
		city: "Pescara",
		plate: "PE", 
		region: "Abruzzo"
	},
	{
		city: "Piacenza",
		plate: "PC", 
		region: "Emilia Romagna"
	},
	{
		city: "Pisa",
		plate: "PI", 
		region: "Toscana"
	},
	{
		city: "Pistoia",
		plate: "PT", 
		region: "Toscana"
	},
	{
		city: "Pordenone",
		plate: "PN", 
		region: "Friuli Venezia Giulia"
	},
	{
		city: "Potenza",
		plate: "PZ", 
		region: "Basilicata"
	},
	{
		city: "Prato",
		plate: "PO", 
		region: "Toscana"
	},
	{
		city: "Ragusa",
		plate: "RG", 
		region: "Sicilia"
	},
	{
		city: "Ravenna",
		plate: "RA", 
		region: "Emilia Romagna"
	},
	{
		city: "Reggio Calabria",
		plate: "RC", 
		region: "Calabria"
	},
	{
		city: "Reggio Emilia",
		plate: "RE", 
		region: "Emilia Romagna"
	},
	{
		city: "Rieti",
		plate: "RI", 
		region: "Lazio"
	},
	{
		city: "Rimini",
		plate: "RN", 
		region: "Emilia Romagna"
	},
	{
		city: "Roma",
		plate: "RM",
		region: "Lazio"
	},
	{
		city: "Rovigo",
		plate: "RO", 
		region: "Veneto"
	},
	{
		city: "Salerno",
		plate: "SA", 
		region: "Campania"
	},
	{
		city: "Sassari",
		plate: "SS", 
		region: "Sardegna"
	},
	{
		city: "Savona",
		plate: "SV", 
		region: "Liguria"
	},
	{
		city: "Siena",
		plate: "SI", 
		region: "Toscana"
	},
	{
		city: "Siracusa",
		plate: "SR", 
		region: "Sicilia"
	},
	{
		city: "Sondrio",
		plate: "SO", 
		region: "Lombardia"
	},
	{
		city: "Taranto",
		plate: "TA", 
		region: "Puglia"
	},
	{
		city: "Teramo",
		plate: "TE", 
		region: "Abruzzo"
	},
	{
		city: "Terni",
		plate: "TR", 
		region: "Umbria"
	},
	{
		city: "Torino",
		plate: "TO", 
		region: "Piemonte"
	},
	{
		city: "Trapani",
		plate: "TP", 
		region: "Sicilia"
	},
	{
		city: "Trento",
		plate: "TN", 
		region: "Trentino Alto Adige"
	},
	{
		city: "Treviso",
		plate: "TV", 
		region: "Veneto"
	},
	{
		city: "Trieste",
		plate: "TS", 
		region: "Friuli Venezia Giulia"
	},
	{
		city: "Udine",
		plate: "UD", 
		region: "Friuli Venezia Giulia"
	},
	{
		city: "Varese",
		plate: "VA", 
		region: "Lombardia"
	},
	{
		city: "Venezia",
		plate: "VE", 
		region: "Veneto"
	},
	{
		city: "Verbania",
		plate: "VB", 
		region: "Piemonte"
	},
	{
		city: "Vercelli",
		plate: "VC", 
		region: "Piemonte"
	},
	{
		city: "Verona",
		plate: "VR", 
		region: "Veneto"
	},
	{
		city: "Vibo Valentia",
		plate: "VV", 
		region: "Calabria"
	},
	{
		city: "Vicenza",
		plate: "VI", 
		region: "Veneto"
	},
	{
		city: "Viterbo",
		plate: "VT", 
		region: "Lazio"
	}
];

export default provinceList;